const LoggedInTabTracker = {
  isLoggedInFromCurrentTab: false,
};

export default LoggedInTabTracker;
